import { EditOutlined } from '@mui/icons-material';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  Stack,
  IconButton,
  TableBody,
} from '@mui/material';
import React from 'react';
import { COMMISSION_PICKS } from '../../../constants';
import FormNumberInput from '../../molecules/FormNumberInput';
import { styles } from './styles';
import usePermissions from '../../../hooks/usePermissions';
import { Control, FieldErrors } from 'react-hook-form';
import type { input, output } from 'zod';
import { commissionSchema } from '../../../schema';

type CommissionPerPickTableProps = {
  control: Control<input<typeof commissionSchema>, unknown, output<typeof commissionSchema>>;
  errors: FieldErrors<input<typeof commissionSchema>>;
  disabled?: boolean;
};

const CommissionPerPickTable = ({ control, errors, disabled = false }: CommissionPerPickTableProps) => {
  const [isEditTableMode, setIsEditTableMode] = React.useState(false);
  const { hasPermission } = usePermissions();

  const canEditCommission = hasPermission('editPartnerCommission');

  return (
    <TableContainer component={Paper} sx={styles.tableContainer}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align='center' sx={styles.rightBorderCell}>
              <Typography
                variant='h6'
                sx={{
                  fontWeight: 600,
                }}
              >
                Picks
              </Typography>
            </TableCell>
            <TableCell align='center'>
              <Stack
                direction='row'
                sx={{
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  variant='h6'
                  sx={{
                    textAlign: 'end',
                    width: '52%',
                  }}
                >
                  %
                </Typography>
                {canEditCommission && !disabled && (
                  <IconButton sx={styles.editButton} onClick={() => setIsEditTableMode(true)}>
                    <EditOutlined color={isEditTableMode ? 'disabled' : 'primary'} />
                  </IconButton>
                )}
              </Stack>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {COMMISSION_PICKS.map((pick) => (
            <TableRow key={pick}>
              <TableCell align='center' sx={styles.rightBorderCell}>
                <Typography
                  variant='h6'
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  {pick}
                </Typography>
              </TableCell>
              <TableCell align='center' padding='none'>
                <FormNumberInput
                  control={control}
                  name={`picks.${pick}`}
                  fullWidth
                  allowDecimals
                  valueAsString
                  error={errors.picks?.[pick]}
                  showHelperText={false}
                  disabled={disabled || !isEditTableMode}
                  sx={styles.perPickInput}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CommissionPerPickTable;
